import React from "react";
import ShopsPage from "../shops";

export default function WishlistShopsPage() {
    return <ShopsPage initialFilter="wishlist" />;
}
